import React, { useState } from "react";
import { Button, Table, Popover, InputNumber, Select, Tabs } from "antd";
import { Navigate, useNavigate } from "react-router-dom";

const { TabPane } = Tabs;


const editableCols = [
  { key: "oil", label: "Oil" },
  { key: "toordhal", label: "Toor Dhal" },
  { key: "sambarmasala", label: "Sambar Masala" },
  { key: "soya", label: "Soya" },
  { key: "corriander", label: "Corriander" },
  { key: "chillypowder", label: "Chilly Powder" },
];


const baseData = [
  {
    key: "01",
    mspc: "Karwar",
    project: "Karwar",
    oil: 1,
    toordhal: 1,
    sambarmasala: 9,
    soya: 9,
    corriander: 9,
    chillypowder: 9,
    total: 9,
  },
  {
    key: "02",
    mspc: "Karwar",
    project: "Karwar",
    oil: 1,
    toordhal: 1,
    sambarmasala: 9,
    soya: 9,
    corriander: 9,
    chillypowder: 9,
    total: 9,
  },
   {
    key: "03",
    mspc: "Karwar",
    project: "Karwar",
    oil: 1,
    toordhal: 3,
    sambarmasala: 7,
    soya: 9,
    corriander: 8,
    chillypowder: 6,
    total: 34,
  },
  {
    key: "04",
    mspc: "Karwar",
    project: "Karwar",
    oil: 1,
    toordhal: 2,
    sambarmasala: 9,
    soya: 9,
    corriander: 9,
    chillypowder: 9,
    total: 39,
  },
  {
    key: "05",
    mspc: "Karwar",
    project: "Karwar",
    oil: 1,
    toordhal: 2,
    sambarmasala: 9,
    soya: 9,
    corriander: 9,
    chillypowder: 9,
    total: 39,
  },
  
];


const months = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

function RM_Calculation() {
  
  const [data, setData] = useState(() => baseData.map(row => ({ ...row })));
  const [editing, setEditing] = useState(null);
  const [editValue, setEditValue] = useState(0);

  const [pdMonth, setPdMonth] = useState("Aug");
  const [fgMonth, setFgMonth] = useState("Aug");
  const [drmsMonth, setDrmsMonth] = useState("Aug");
  const navigate=useNavigate();
  const handleEditCell = (rowIndex, colKey) => {
    setEditing({ row: rowIndex, col: colKey });
    setEditValue(data[rowIndex][colKey]);
  };

  const handleApply = () => {
    if (editing) {
      const newData = [...data];
      newData[editing.row][editing.col] = editValue;
      setData(newData);
      setEditing(null);
    }
  };

  const handleReset = () => {
    
    const resetData = baseData.map(row => ({ ...row }));
    setData(resetData);
    setEditing(null);
  };

  
  const columns = [
    { title: "MSPC", dataIndex: "mspc", key: "mspc" },
    { title: "Project", dataIndex: "project", key: "project" },
    ...editableCols.map(col => ({
      title: col.label,
      dataIndex: col.key,
      key: col.key,
      render: (text, record, rowIndex) => (
        <Popover
          title={
            <span style={{ fontWeight: 500, color: "#1665D8", fontSize: 15 }}>
              {`Edit Months - ${col.label}`}
            </span>
          }
          content={
            <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 170 }}>
              <Button size="small" onClick={() => setEditValue(v => Math.max(Number(v) - 1, 0))}>-</Button>
              <InputNumber
                min={0}
                value={Number(editing?.row === rowIndex && editing?.col === col.key ? editValue : data[rowIndex][col.key])}
                onChange={setEditValue}
                style={{ width: 50 }}
              />
              <Button size="small" onClick={() => setEditValue(v => Number(v) + 1)}>+</Button>
              <Button
                type="primary"
                size="small"
                style={{ background: "#1665D8", borderColor: "#1665D8" }}
                onClick={handleApply}
              >
                Apply
              </Button>
            </div>
          }
          trigger="click"
          open={editing?.row === rowIndex && editing?.col === col.key}
          onOpenChange={visible =>
            visible ? handleEditCell(rowIndex, col.key) : setEditing(null)
          }
          placement="bottom"
        >
          <span style={{ cursor: "pointer" }}>
            {data[rowIndex][col.key]} T
          </span>
        </Popover>
      ),
    })),
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (text) => `${text} T`,
    },
  ];

  return (
    <div style={{ background: "#fafcff", padding: 12, minHeight: "100vh" }}>
      
      <div style={{ display: "flex", gap: 10, marginBottom: 14, alignItems: "center" }}>
        <Button>File: KTKKAR0825</Button>
        <Button>Month: June 2025</Button>
        <Button>T.B: 1245434</Button>
        <Button style={{ background: "lightgrey" }}>Pusthi</Button>
        <Tabs defaultActiveKey="all" style={{ marginLeft: "auto" }}>
          <TabPane tab="All" key="all" />
          <TabPane tab="Production" key="production" />
          <TabPane tab="Kit" key="kit" />
        </Tabs>
      </div>

      
      <div style={{ display: "flex", alignItems: "center", gap: 35, marginBottom: 10 }}>
        <span style={{ minWidth: 135, color: "#334" }}>Serving PD Master</span>
        <Select
          value={`Pusthi - ${pdMonth}`}
          style={{ width: 140 }}
          onChange={month => setPdMonth(month)}
        >
          {months.map(m => (
            <Select.Option key={m} value={m}>Pusthi - {m}</Select.Option>
          ))}
        </Select>

        <span style={{ minWidth: 135, marginLeft: 35, color: "#334" }}>Formula FG Master</span>
        <Select
          value={`Pusthi - ${fgMonth}`}
          style={{ width: 140 }}
          onChange={month => setFgMonth(month)}
        >
          {months.map(m => (
            <Select.Option key={m} value={m}>Pusthi - {m}</Select.Option>
          ))}
        </Select>

        <span style={{ minWidth: 120, marginLeft: 35, color: "#334" }}>DRMS Split</span>
        <Select
          value={`DRMS-${drmsMonth}`}
          style={{ width: 120 }}
          onChange={month => setDrmsMonth(month)}
        >
          {months.map(m => (
            <Select.Option key={m} value={m}>DRMS-{m}</Select.Option>
          ))}
        </Select>
      </div>

      {/* Table */}
      <Table
        rowSelection={{}}
        columns={columns}
        dataSource={data}
        pagination={false}
        scroll={{ y: 300 }}
        bordered
        size="middle"
      />

      {/* Footer */}
      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "flex-end",
          background: "#f5f5f5",
          padding: 12,
          borderRadius: 6
        }}
      >
        <Button style={{ marginRight: 12 }} onClick={handleReset}>
          Reset Original
        </Button>
       <Button type="primary" onClick={() => navigate("/master/rm_cal")}>UPDATE</Button>

      </div>
    </div>
  );
}

export default RM_Calculation;
